import XMEnum from './XMEnum';

const CheckSpecEnum = new XMEnum([
  {
    name: 'EMPTY_STOCK',
    describe: '已抢光，请联系机构',
    continueDesc: '库存不足，请联系机构或重新下单'
  },
  {
    name: 'STOCK_NOT_ENOUGH',
    describe: '库存不足，请修改购买数量',
    continueDesc: '库存不足，请联系机构或重新下单'
  },
  {
    name: 'SPEC_STOCK_NOT_ENOUGH',
    describe: '库存不足，请选择别的规格',
    continueDesc: '库存不足，请联系机构或重新下单'
  },
  {
    name: 'CLASS_NOT_ALLOW_ONLINE_SELECT',
    describe: '不支持在线选班，请选择其他班级',
    continueDesc: '不支持选班，请联系机构或重新下单'
  },
  {
    name: 'CLASS_GRADUATION',
    describe: '班级已结业，请选择其他班级',
    continueDesc: '班级已结业，请联系机构或重新下单'
  },
  {
    name: 'CLASS_FULL',
    describe: '班级已满员，请选择其他班级',
    continueDesc: '班级已满员，请联系机构或重新下单'
  }
]);

const CategoryUnitEnum = new XMEnum([
  { name: 'GOODS', unit: 'PIECE', describe: '件' },
  { name: 'FEE_ITEM', unit: 'PACKET', describe: '笔' }
]);

export {
  CheckSpecEnum,
  CategoryUnitEnum
};



// WEBPACK FOOTER //
// ./src/enum/MallEnum.js